<div class="relative">
  <div class="flex items-center justify-between mb-4">
    <h3 data-element="knowledge-dialog-title">{{ isNewItem ? 'New knowledge' : 'Edit knowledge' }}</h3>
    <sbnb-close data-element="knowledge-dialog-close" (click)="dialogRef.close()"></sbnb-close>
  </div>

  <div class="flex items-center gap-2 mb-8">
    <mat-form-field class="w-[300px] nopadding">
      <mat-select
        [formControl]="topicId"
        data-element="knowledge-topic-select"
        *ngIf="!isAddingNewTopic">
        <mat-option *ngFor="let topic of data.topics" [value]="topic.id">
          {{ topic.name }}
        </mat-option>
      </mat-select>

      <input
        matInput
        [formControl]="newTopicName"
        placeholder="Enter new topic name"
        data-element="knowledge-new-topic-input"
        *ngIf="isAddingNewTopic" />
    </mat-form-field>

    <sbnb-button
      [type]="isAddingNewTopic ? 'text-secondary' : 'text'"
      [label]="isAddingNewTopic ? 'Cancel' : '+ Add topic'"
      size="mini"
      (clicked)="toggleNewTopic()"
      data-element="knowledge-toggle-new-topic-button"></sbnb-button>
  </div>

  <div class="flex flex-col gap-2 mb-8">
    <sbnb-textarea
      class="block"
      [formControl]="content"
      placeholder="Write your knowledge here..."
      [maxRows]="16"
      (input)="onContentInput($event)"
      data-element="knowledge-content-textarea"></sbnb-textarea>
  </div>

  <div class="flex justify-end">
    <sbnb-button
      [loading]="saving"
      [disabled]="(isAddingNewTopic && !newTopicName.valid) || !content.valid"
      (clicked)="saveChanges()"
      data-element="knowledge-save-button">
      Save changes
    </sbnb-button>
  </div>
</div>
